var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8105 1.49988C13.6186 1.49988 13.4265 1.57298 13.2803 1.7196L12 2.99988L15 5.99988L16.2803 4.7196C16.5735 4.42635 16.5735 3.95156 16.2803 3.65906L14.3408 1.7196C14.1942 1.57298 14.0025 1.49988 13.8105 1.49988ZM10.875 4.12488L2.25 12.7499V15.7499H5.25L13.875 7.12488L10.875 4.12488Z",
    fill: "#4B9BF5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.5abef9cd02ae2186d0c4f0095252a253.svg";
export { ForwardRef as ReactComponent };